import { FieldDesc } from '90.quickConnect.Models/models';

const getFieldKey = ({ fullPathId }: FieldDesc): string => `stateId:${fullPathId}`;

export default getFieldKey;
